(function () {

  'use strict';

  var CARD_VARIANT_ID = 47692607750315;

  var WRAP_VARIANT_ID = 47692607783083;

  var EXTRA_WRAP_VARIANT_ID = 47701244346539;

  var running = false;

  var removing = false;

  var rerunTimer = null;

  function money(cents) {

    try {

      return new Intl.NumberFormat('en-AU', {

        style: 'currency',

        currency: 'AUD'

      }).format(Number(cents || 0) / 100);

    } catch (error) {

      return '$' + (Number(cents || 0) / 100).toFixed(2);

    }

  }

  function escapeHTML(value) {

    var div = document.createElement('div');

    div.textContent =

      value == null ? '' : String(value);

    return div.innerHTML;

  }

  function capitaliseFirst(value) {

    value = String(value || '').trim();

    if (!value) {

      return '';

    }

    return value.charAt(0).toUpperCase() +

      value.slice(1);

  }

  function getGiftReference(item) {

    if (!item || !item.properties) {

      return '';

    }

    return item.properties['_Gift reference'] || '';

  }

  function getProperty(item, name) {

    if (!item || !item.properties) {

      return '';

    }

    return item.properties[name] || '';

  }

  /*

   * OLD + NEW PROPERTY COMPATIBILITY

   */

  function getRecipient(item) {

    return (

      getProperty(item, 'Recipient') ||

      getProperty(item, '_Recipient') ||

      getProperty(item, '_Gift for') ||

      getProperty(item, 'Gift for') ||

      ''

    );

  }

  function getServiceName(item) {

    return (

      getProperty(item, '_Service') ||

      getProperty(item, 'Service') ||

      getProperty(item, 'Gift service') ||

      ''

    );

  }

  function getCardMessage(item) {

    return (

      getProperty(item, 'Card message') ||

      getProperty(item, 'Personalised card') ||

      ''

    );

  }

  function isGiftService(item) {

    var id = Number(item.variant_id);

    return (

      id === CARD_VARIANT_ID ||

      id === WRAP_VARIANT_ID ||

      id === EXTRA_WRAP_VARIANT_ID

    );

  }

  function isMainGiftService(item) {

    var id = Number(item.variant_id);

    return (

      id === CARD_VARIANT_ID ||

      id === WRAP_VARIANT_ID

    );

  }

  function getCart() {

    return fetch('/cart.js', {

      method: 'GET',

      headers: {

        'Accept': 'application/json'

      }

    }).then(function (response) {

      if (!response.ok) {

        throw new Error(

          'Could not read cart.'

        );

      }

      return response.json();

    });

  }

  function groupGiftItems(cart) {

    var groups = {};

    cart.items.forEach(function (item) {

      var reference =

        getGiftReference(item);

      if (!reference) {

        return;

      }

      if (!groups[reference]) {

        groups[reference] = {

          reference: reference,

          items: [],

          products: [],

          serviceItems: [],

          mainService: null,

          recipient: '',

          serviceName: '',

          message: '',

          physicalQuantity: 0,

          serviceTotal: 0

        };

      }

      var group =

        groups[reference];

      group.items.push(item);

      if (isGiftService(item)) {

        group.serviceItems.push(item);

        group.serviceTotal += Number(

          item.final_line_price || 0

        );

        if (isMainGiftService(item)) {

          group.mainService =

            item;

          group.recipient =

            getRecipient(item) ||

            group.recipient;

          group.serviceName =

            getServiceName(item) ||

            group.serviceName;

          group.message =

            getCardMessage(item) ||

            group.message;

        }

      } else {

        group.products.push(item);

        group.physicalQuantity += Number(

          item.quantity || 0

        );

        if (!group.recipient) {

          group.recipient =

            getRecipient(item);

        }

      }

    });

    return groups;

  }

  function findRowsForCartItems(root, cart) {

    var rows =

      Array.prototype.slice.call(

        root.querySelectorAll('.cart-item')

      );

    var usedRows = [];

    var matches = [];

    cart.items.forEach(function (item) {

      var matchingRow = null;

      for (

        var i = 0;

        i < rows.length;

        i += 1

      ) {

        if (

          usedRows.indexOf(rows[i]) !== -1

        ) {

          continue;

        }

        var rowVariantId =

          Number(

            rows[i].getAttribute(

              'data-variant-id'

            )

          );

        if (

          rowVariantId ===

          Number(item.variant_id)

        ) {

          matchingRow =

            rows[i];

          break;

        }

      }

      if (matchingRow) {

        usedRows.push(

          matchingRow

        );

        matches.push({

          item: item,

          row: matchingRow

        });

      }

    });

    return matches;

  }

  function getRowForItem(

    matches,

    item

  ) {

    for (

      var i = 0;

      i < matches.length;

      i += 1

    ) {

      if (

        matches[i].item === item

      ) {

        return matches[i].row;

      }

    }

    return null;

  }

  function resetDisplay(root) {

    root

      .querySelectorAll(

        '.th-gift-summary-row'

      )

      .forEach(function (element) {

        element.remove();

      });

    root

      .querySelectorAll(

        '.th-gift-product-quantity'

      )

      .forEach(function (element) {

        element.remove();

      });

    root

      .querySelectorAll(

        '.cart-item[data-th-gift-display]'

      )

      .forEach(function (row) {

        row.style.display = '';

        row.removeAttribute(

          'data-th-gift-display'

        );

        row.classList.remove(

          'th-gift-product-row',

          'th-gift-service-row'

        );

        var variants =

          row.querySelector(

            '.cart-item__variants'

          );

        if (variants) {

          var propertyRows =

            variants.querySelectorAll(

              'dl > div'

            );

          propertyRows.forEach(

            function (propertyRow) {

              propertyRow.style.display =

                '';

            }

          );

        }

        var quantity =

          row.querySelector(

            '.cart-item__qty'

          );

        if (quantity) {

          quantity.style.display =

            '';

        }

      });

  }

  function buildGiftSummary(group) {

    var tr =

      document.createElement('tr');

    tr.className =

      'th-gift-summary-row cart-item grid gap-x-8';

    tr.setAttribute(

      'data-th-gift-reference',

      group.reference

    );

    var recipient =

      capitaliseFirst(

        group.recipient ||

        'Recipient'

      );

    var serviceName =

      group.serviceName ||

      'Gift service';

    var physicalQuantity =

      group.physicalQuantity;

    var serviceTotal =

      group.serviceTotal;

    var serviceDescription =

      '';

    if (

      group.mainService &&

      Number(

        group.mainService.variant_id

      ) === WRAP_VARIANT_ID

    ) {

      serviceDescription =

        physicalQuantity +

        (

          physicalQuantity === 1

            ? ' item'

            : ' items'

        ) +

        ' being gift wrapped';

    } else {

      serviceDescription =

        'Personalised card included';

    }

    var messageHTML =

      '';

    if (group.message) {

      messageHTML =

        '<div class="th-gift-display-message">' +

          '<strong>Card message</strong>' +

          '<div>' +

            escapeHTML(

              group.message

            ) +

          '</div>' +

        '</div>';

    }

    tr.innerHTML =

      '<td class="th-gift-display-card" colspan="4">' +

        '<div class="th-gift-display-heading">' +

          '<span class="th-gift-display-icon" aria-hidden="true">' +

            '🎁' +

          '</span>' +

          '<div>' +

            '<div class="th-gift-display-label">' +

              'GIFT' +

            '</div>' +

            '<div class="th-gift-display-title">' +

              'Gift for ' +

              escapeHTML(

                recipient

              ) +

            '</div>' +

          '</div>' +

        '</div>' +

        '<div class="th-gift-display-service">' +

          '<div>' +

            '<strong>' +

              escapeHTML(

                serviceName

              ) +

            '</strong>' +

            '<span>' +

              escapeHTML(

                serviceDescription

              ) +

            '</span>' +

          '</div>' +

          '<strong class="th-gift-display-price">' +

            money(

              serviceTotal

            ) +

          '</strong>' +

        '</div>' +

        messageHTML +

        '<div class="th-gift-display-footer">' +

          '<div class="th-gift-display-note">' +

            'The products below are included in this gift.' +

          '</div>' +

          '<button type="button" ' +

            'class="th-remove-gift" ' +

            'data-gift-reference="' +

            escapeHTML(

              group.reference

            ) +

            '">' +

            'Remove gift' +

          '</button>' +

        '</div>' +

      '</td>';

    return tr;

  }

  /*

   * Cleans the customer-facing gift product row

   * and adds a clear, non-editable quantity label.

   */

  function cleanProductRow(row, item) {

    if (!row) {

      return;

    }

    row.setAttribute(

      'data-th-gift-display',

      'product'

    );

    row.classList.add(

      'th-gift-product-row'

    );

    var oldQuantityLabel =

      row.querySelector(

        '.th-gift-product-quantity'

      );

    if (oldQuantityLabel) {

      oldQuantityLabel.remove();

    }

    var variants =

      row.querySelector(

        '.cart-item__variants'

      );

    if (variants) {

      var propertyRows =

        variants.querySelectorAll(

          'dl > div'

        );

      propertyRows.forEach(

        function (propertyRow) {

          var dt =

            propertyRow.querySelector(

              'dt'

            );

          if (!dt) {

            return;

          }

          var label =

            dt.textContent

              .replace(':', '')

              .trim()

              .toLowerCase();

          if (

            label === 'gift' ||

            label === '_gift' ||

            label === 'gift quantity' ||

            label === '_gift quantity' ||

            label === 'gift for' ||

            label === '_gift for' ||

            label === 'recipient' ||

            label === '_recipient' ||

            label === 'service' ||

            label === '_service' ||

            label === 'gift contains' ||

            label === '_gift contains' ||

            label === 'card message' ||

            label === 'for gift' ||

            label === '_for gift' ||

            label === 'wrapping for' ||

            label === '_wrapping for'

          ) {

            propertyRow.style.display =

              'none';

          }

        }

      );

      if (item) {

        var quantityLabel =

          document.createElement('div');

        quantityLabel.className =

          'th-gift-product-quantity';

        quantityLabel.innerHTML =

          '<strong>Qty:</strong> ' +

          escapeHTML(

            String(item.quantity || 1)

          );

        variants.appendChild(

          quantityLabel

        );

      }

    }

    /*

     * Keep the normal Shopify quantity controls

     * hidden for gift products. Changing quantities

     * here would break the gift-wrapping calculation.

     */

    var quantity =

      row.querySelector(

        '.cart-item__qty'

      );

    if (quantity) {

      quantity.style.display =

        'none';

    }

  }

  function hideServiceRow(row) {

    if (!row) {

      return;

    }

    row.setAttribute(

      'data-th-gift-display',

      'service'

    );

    row.classList.add(

      'th-gift-service-row'

    );

    row.style.display =

      'none';

  }

  function removeGift(

    reference,

    button

  ) {

    if (removing) {

      return;

    }

    removing =

      true;

    button.disabled =

      true;

    button.textContent =

      'Removing gift...';

    getCart()

      .then(function (cart) {

        var updates = {};

        cart.items.forEach(

          function (item) {

            if (

              getGiftReference(item) ===

              reference

            ) {

              updates[item.key] =

                0;

            }

          }

        );

        if (

          !Object.keys(updates).length

        ) {

          throw new Error(

            'Gift lines could not be found.'

          );

        }

        return fetch(

          '/cart/update.js',

          {

            method:

              'POST',

            headers: {

              'Content-Type':

                'application/json',

              'Accept':

                'application/json'

            },

            body:

              JSON.stringify({

                updates:

                  updates

              })

          }

        );

      })

      .then(function (response) {

        if (!response.ok) {

          throw new Error(

            'Gift could not be removed.'

          );

        }

        return response.json();

      })

      .then(function () {

        window.location.reload();

      })

      .catch(function () {

        removing =

          false;

        button.disabled =

          false;

        button.textContent =

          'Remove gift';

        window.alert(

          'We could not remove this gift. Please try again.'

        );

      });

  }

  function addStyles() {

    if (

      document.getElementById(

        'th-gift-cart-display-styles'

      )

    ) {

      return;

    }

    var style =

      document.createElement(

        'style'

      );

    style.id =

      'th-gift-cart-display-styles';

    style.textContent =

      '.th-gift-summary-row{' +

        'display:table-row;' +

      '}' +

      '.th-gift-display-card{' +

        'grid-column:1/-1;' +

        'width:100%;' +

        'padding:18px 20px!important;' +

        'margin:0 0 4px;' +

        'border:1px solid #d5e5cf;' +

        'border-radius:10px;' +

        'background:#f8fbf6;' +

        'box-sizing:border-box;' +

      '}' +

      '.th-gift-display-heading{' +

        'display:flex;' +

        'align-items:center;' +

        'gap:11px;' +

        'margin-bottom:14px;' +

      '}' +

      '.th-gift-display-icon{' +

        'display:flex;' +

        'align-items:center;' +

        'justify-content:center;' +

        'width:38px;' +

        'height:38px;' +

        'border-radius:50%;' +

        'background:#eef6e9;' +

        'font-size:19px;' +

      '}' +

      '.th-gift-display-label{' +

        'margin-bottom:1px;' +

        'color:#285b32;' +

        'font-size:10px;' +

        'font-weight:800;' +

        'letter-spacing:.14em;' +

      '}' +

      '.th-gift-display-title{' +

        'color:#285b32;' +

        'font-size:20px;' +

        'font-weight:800;' +

        'line-height:1.2;' +

      '}' +

      '.th-gift-display-service{' +

        'display:flex;' +

        'align-items:flex-start;' +

        'justify-content:space-between;' +

        'gap:18px;' +

        'padding:12px 0;' +

        'border-top:1px solid #dce6d8;' +

        'border-bottom:1px solid #dce6d8;' +

      '}' +

      '.th-gift-display-service strong{' +

        'display:block;' +

      '}' +

      '.th-gift-display-service span{' +

        'display:block;' +

        'margin-top:2px;' +

        'font-size:13px;' +

        'opacity:.72;' +

      '}' +

      '.th-gift-display-price{' +

        'white-space:nowrap;' +

        'color:#285b32;' +

      '}' +

      '.th-gift-display-message{' +

        'margin-top:13px;' +

        'padding:11px 13px;' +

        'border-radius:7px;' +

        'background:#fff;' +

        'font-size:13px;' +

        'line-height:1.45;' +

      '}' +

      '.th-gift-display-message strong{' +

        'display:block;' +

        'margin-bottom:3px;' +

        'color:#285b32;' +

      '}' +

      '.th-gift-display-footer{' +

        'display:flex;' +

        'align-items:center;' +

        'justify-content:space-between;' +

        'gap:16px;' +

        'margin-top:12px;' +

      '}' +

      '.th-gift-display-note{' +

        'font-size:12px;' +

        'opacity:.68;' +

      '}' +

      '.th-remove-gift{' +

        'appearance:none;' +

        'border:0;' +

        'padding:0;' +

        'background:transparent;' +

        'color:#6b4038;' +

        'font:inherit;' +

        'font-size:12px;' +

        'font-weight:700;' +

        'text-decoration:underline;' +

        'text-underline-offset:2px;' +

        'cursor:pointer;' +

        'white-space:nowrap;' +

      '}' +

      '.th-remove-gift:hover{' +

        'color:#3f2520;' +

      '}' +

      '.th-remove-gift:disabled{' +

        'opacity:.55;' +

        'cursor:wait;' +

      '}' +

      '.th-gift-product-row{' +

        'position:relative;' +

        'background:#fcfdfb;' +

        'border-left:3px solid #a8cf98;' +

        'padding-left:12px;' +

      '}' +

      '.th-gift-product-quantity{' +

        'margin-top:4px;' +

        'font-size:13px;' +

        'line-height:1.4;' +

        'color:inherit;' +

      '}' +

      '.th-gift-product-quantity strong{' +

        'font-weight:700;' +

      '}' +

      '@media(max-width:749px){' +

        '.th-gift-display-card{' +

          'padding:15px!important;' +

        '}' +

        '.th-gift-display-title{' +

          'font-size:18px;' +

        '}' +

        '.th-gift-display-service{' +

          'gap:10px;' +

        '}' +

        '.th-gift-display-footer{' +

          'align-items:flex-start;' +

          'flex-direction:column;' +

          'gap:8px;' +

        '}' +

        '.th-gift-product-row{' +

          'padding-left:8px;' +

        '}' +

      '}';

    document.head.appendChild(

      style

    );

  }

  function renderGiftDisplay(cart) {

    var root =

      document.getElementById(

        'cart-items'

      );

    if (!root) {

      return;

    }

    resetDisplay(root);

    addStyles();

    var groups =

      groupGiftItems(cart);

    var matches =

      findRowsForCartItems(

        root,

        cart

      );

    Object.keys(groups).forEach(

      function (reference) {

        var group =

          groups[reference];

        if (

          !group.products.length ||

          !group.mainService

        ) {

          return;

        }

        var firstProductRow =

          getRowForItem(

            matches,

            group.products[0]

          );

        if (!firstProductRow) {

          return;

        }

        group.serviceItems.forEach(

          function (serviceItem) {

            hideServiceRow(

              getRowForItem(

                matches,

                serviceItem

              )

            );

          }

        );

        group.products.forEach(

          function (productItem) {

            cleanProductRow(

              getRowForItem(

                matches,

                productItem

              ),

              productItem

            );

          }

        );

        var summary =

          buildGiftSummary(

            group

          );

        firstProductRow.parentNode

          .insertBefore(

            summary,

            firstProductRow

          );

      }

    );

  }

  // Only used by the Stage 1 “Review my existing gift” navigation.
  var focusedGiftReviewHash = null;

  function focusRequestedGiftSummary() {
    var hash = window.location.hash || '';
    if (hash !== '#th-gift-review' && hash.indexOf('#th-gift-review=') !== 0) return;
    if (focusedGiftReviewHash === hash) return;
    var reference = '';
    if (hash.indexOf('=') !== -1) {
      try { reference = decodeURIComponent(hash.slice(hash.indexOf('=') + 1)); }
      catch (error) { return; }
    }
    var root = document.getElementById('cart-items');
    if (!root) return;
    var summaries = root.querySelectorAll('.th-gift-summary-row');
    for (var i = 0; i < summaries.length; i += 1) {
      if (!reference || summaries[i].getAttribute('data-th-gift-reference') === reference) {
        summaries[i].setAttribute('tabindex', '-1');
        summaries[i].focus({preventScroll: true});
        summaries[i].scrollIntoView({behavior: 'smooth', block: 'center'});
        focusedGiftReviewHash = hash;
        return;
      }
    }
  }

  window.addEventListener('hashchange', function () {
    focusedGiftReviewHash = null;
    focusRequestedGiftSummary();
  });

  function run() {

    if (

      running ||

      removing

    ) {

      return;

    }

    running =

      true;

    getCart()

      .then(function (cart) {

        renderGiftDisplay(

          cart

        );

        focusRequestedGiftSummary();

      })

      .catch(function (error) {

        console.warn(

          'Tropical Harvest gift cart display:',

          error

        );

      })

      .then(function () {

        running =

          false;

      });

  }

  function scheduleRun() {

    clearTimeout(

      rerunTimer

    );

    rerunTimer =

      setTimeout(

        run,

        250

      );

  }

  /*

   * Handle Remove gift using event delegation,

   * because the gift summary is created dynamically.

   */

  document.addEventListener(

    'click',

    function (event) {

      var button =

        event.target.closest(

          '.th-remove-gift'

        );

      if (!button) {

        return;

      }

      event.preventDefault();

      var reference =

        button.getAttribute(

          'data-gift-reference'

        );

      if (!reference) {

        return;

      }

      removeGift(

        reference,

        button

      );

    }

  );

  if (

    document.readyState ===

    'loading'

  ) {

    document.addEventListener(

      'DOMContentLoaded',

      run

    );

  } else {

    run();

  }

  var observer =

    new MutationObserver(

      function (mutations) {

        var shouldRun =

          false;

        mutations.forEach(

          function (mutation) {

            if (

              mutation.addedNodes.length ||

              mutation.removedNodes.length

            ) {

              shouldRun =

                true;

            }

          }

        );

        if (shouldRun) {

          scheduleRun();

        }

      }

    );

  function startObserver() {

    var root =

      document.getElementById(

        'cart-items'

      );

    if (!root) {

      return;

    }

    observer.observe(

      root,

      {

        childList:

          true,

        subtree:

          true

      }

    );

  }

  if (

    document.readyState ===

    'loading'

  ) {

    document.addEventListener(

      'DOMContentLoaded',

      startObserver

    );

  } else {

    startObserver();

  }

})();